import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        light: true,
        themes: {
            light: {
                primary: '#242C6B',
                secondary: '#E6E7E8',
                ".v-text-field__slot .input": { color: '#E6E7E8' }
            },
            dark: {
                background: '#FFFFFF'
            }
        }
    }
});
